import React from 'react'

import { MiEquipo } from './MiEquipo';
import { MisCartas } from './MisCartas'
import { Row, Tabs, Typography } from 'antd';
import { useMiEquipo } from '../../../Hooks/Player';

const { Title, Paragraph } = Typography;

export const Home = () => {
  
  const { data, isFetching: cargandoData, refetch } = useMiEquipo();

  const tabs = [
    {
      label: `Mis Equipos`,
      key: 1,
      children: <MiEquipo data={data} cargandoData={cargandoData} refetch={refetch}/>
    },
    {
      label: `Mis Cartas`,
      key: 2,
      children: <MisCartas refetch={refetch}/>
    }
  ]

  return (
    <>
      <Typography direction="vertical" style={{ marginTop: "5%", marginLeft: "5%" }}>
          <Row>
            <Title level={1} style={{ marginTop: "0%", fontFamily: "POKEFONT" }}>Mis EQUIPOS</Title>
          </Row>
          <Paragraph style={{ marginTop: "-15px" }}>Administra tus equipos y tus cartas</Paragraph>
      </Typography>
      <Tabs
        defaultActiveKey="1"
        centered
        items={tabs}
        />
        
    </>
  )
}
